import { FC } from 'react'
import { Section } from 'types/faq'
import { FaqCategoriesProps as Props } from './types'
import styles from './FaqCategories.module.scss'

const FaqCategories: FC<Props> = ({ sections, setSelectedQuestionId }) => {
  const handleCategoryClick = (sectionId: string) => {
    setSelectedQuestionId(null)
    const section = document.getElementById(sectionId)
    const yPosition = section.getBoundingClientRect().top + window.pageYOffset - 100

    window.scrollTo({ top: yPosition, behavior: 'smooth' })
  }

  return (
    <div className={styles.categories}>
      {sections.map((section: Section) => (
        <div key={section.id} className={styles.category}>
          <button onClick={() => handleCategoryClick(section.id.toString())}>
            <span>{section.name}</span>
          </button>
        </div>
      ))}
    </div>
  )
}

FaqCategories.defaultProps = {
  setSelectedQuestionId: null
}

export default FaqCategories
